import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { clanky } from '../data/clanky';
import SEO from '../common/SEO';
import SafeIcon from '../common/SafeIcon';

const KnowHowPage = () => {
  const sortedArticles = [...clanky].sort(
    (a, b) => new Date(b.datum) - new Date(a.datum)
  );

  const calculateReadingTime = (obsah) => {
    const wordCount = obsah.reduce((acc, curr) => {
      if (curr.text) return acc + curr.text.split(/\s+/).length;
      if (curr.polozky) return acc + curr.polozky.join(' ').split(/\s+/).length;
      return acc;
    }, 0);
    return Math.max(1, Math.ceil(wordCount / 200));
  };

  return (
    <>
      <SEO
        title="Know-how – technické články o světelné reklamě | LightWell"
        description="Odborné články a technické rady pro výrobce světelné reklamy. Naučte se, jak optimalizovat zapojení, zvolit správné napětí a maximalizovat životnost LED systémů."
        path="/know-how"
      />
      <div className="pt-20">
        <section className="bg-gray-50 py-24 border-b border-gray-100">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <h1 className="text-5xl md:text-7xl font-bold italic tracking-tighter uppercase text-gray-900 mb-6">
              Know-how
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Technické články a praktické rady pro signmakery a výrobce světelné reklamy.
            </p>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
              {sortedArticles.map((clanek, idx) => (
                <motion.article
                  key={clanek.slug}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.1 }}
                  className="group flex flex-col bg-white border border-gray-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 p-6"
                >
                  {clanek.obrazek && (
                    <Link
                      to={`/know-how/${clanek.slug}`}
                      className="block aspect-[16/9] overflow-hidden rounded-xl bg-white mb-6"
                    >
                      <img
                        src={clanek.obrazek}
                        alt={clanek.nadpis}
                        className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-700"
                      />
                    </Link>
                  )}

                  <div className="flex items-center gap-3 mb-4">
                    <span className="bg-black text-white px-3 py-1 rounded-full text-[9px] font-bold uppercase tracking-widest">
                      Know-how
                    </span>
                    <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
                      {calculateReadingTime(clanek.obsah)} MIN ČTENÍ
                    </span>
                  </div>

                  <hr className="mb-6 border-gray-100" />

                  <h2 className="text-2xl font-normal text-gray-900 mb-4 leading-tight group-hover:text-blue-600 transition-colors">
                    <Link to={`/know-how/${clanek.slug}`}>{clanek.nadpis}</Link>
                  </h2>

                  <p className="text-gray-500 text-sm leading-relaxed mb-8 flex-grow">
                    {clanek.perex}
                  </p>

                  <Link
                    to={`/know-how/${clanek.slug}`}
                    className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-gray-900 group-hover:text-blue-600 transition-all mt-auto"
                  >
                    Číst více <SafeIcon name="ArrowRight" className="w-4 h-4" />
                  </Link>
                </motion.article>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default KnowHowPage;
